module.exports = __webpack_public_path__ + "img/Playstation5.c29e2e39.jpg";